import { Drawer } from '@portals/ui-kit';
import { TDrawerProps } from '@portals/ui-kit/lib/drawer/_components/drawer-view/drawer-view';
import { useScreenSize } from '@portals/react-hooks';
import { ReactNode } from 'react';

type TProps = {
  isOpened: boolean;
  onClose: () => void;
  isInDrawer?: boolean;
  children: ReactNode;
};

export const FeedbackDrawerWrapper = ({
  isInDrawer,
  isOpened,
  onClose,
  children,
}: TProps) => {
  const { mobile: isMobile } = useScreenSize();

  const drawerProps = isInDrawer
    ? ({
        type: 'screen',
      } satisfies Partial<TDrawerProps>)
    : ({
        radius: 'md',
        type: isMobile ? 'sidebar' : 'dialog',
        placement: isMobile ? 'bottom' : 'center',
        size: 'min-content',
        heightBehavior: 'content',
      } satisfies Partial<TDrawerProps>);

  return (
    <Drawer isOpened={isOpened} onClose={onClose} {...drawerProps}>
      {children}
    </Drawer>
  );
};
